import React, {FC, ReactElement} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {IconButton} from '@material-ui/core';
import {Search} from '@material-ui/icons';

const useStyles = makeStyles(_ => ({
    root: {
        padding: 0
    }
}));

interface SearchButtonProps {
    onClick?: () => void
}

const SearchButton: FC<SearchButtonProps> = ({onClick}): ReactElement => {
    const classes = useStyles();

    return (
        <IconButton
            className={classes.root}
            onClick={onClick}>
            <Search/>
        </IconButton>
    );
};

export default SearchButton;
